import { useState } from 'react';
import './App.css';
import Gandata from './Componends/Gandata/Gandata';
import Navar from './Componends/Navbar/Navar';


function App() {
  const [count, SetCount] = useState(0);
  const increaseValue = () => SetCount(count + 1);
  return (
    <div className="App">
      <Navar count={count} />
      <Gandata increaseValue ={increaseValue} />
    </div>
  );
}

export default App;
